import { gql } from "@apollo/client";

// --- create_widget_definition (add widget definition) ---

export interface WidgetDefinitionInput {
  key: string;
  default_name_template: string;
  store_name_template: string;
  category_id: string | null;
  chart_type: string;
  widget_description_template: string;
  widget_help_description_template: string;
  min_height: number;
  min_width: number;
  max_width: number;
  has_time_controller: boolean;
  vertical_legend: boolean;
  is_common: boolean;
  is_clickable: boolean;
  tags: string[];
}

export interface AddWidgetDefinitionVariables {
  widgetDefinition: WidgetDefinitionInput;
}

export interface AddWidgetDefinitionData {
  create_widget_definition: {
    widget_definition_id: string;
  };
}

export const ADD_WIDGET_DEFINITION = gql`
  mutation addWidgetDefinition($widgetDefinition: WidgetDefinitionInput!) {
    create_widget_definition(widget_definition: $widgetDefinition) {
      widget_definition_id
    }
  }
`;
